import React from "react";

import api from "../../store/services/api";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStopwatch,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
export default class ResetCountModal extends React.Component {
  handleSubmit = async (e) => {
    await api.put("/user/resetindex/", {});
    this.props.toggleModal && this.props.toggleModal(e);
  };

  toggleModal = (e) => {
    this.props.toggleModal && this.props.toggleModal(e);
  };

  render() {
    return (
      <div className="overlay" style={{ paddingTop: "2%" }}>
        <div className="overlay__content--center" id="modal">
          <div>
            <p className="text-center" style={{ fontSize: 42 }}>
              <FontAwesomeIcon icon={faStopwatch} />
            </p>
            <p className="text-center text__big">ZERAR CONTAGEM DE PEDIDOS?</p>
          </div>

          <div className="container__float--limits">
            <button
              className="btn btn__right btn--full btn--danger"
              onClick={this.toggleModal}
            >
              <FontAwesomeIcon icon={faThumbsDown} /> NÃO
            </button>
            <button
              className="btn btn__right btn--info"
              style={{ borderRadius: "0 8px 8px 0" }}
              onClick={(e) => this.handleSubmit(this.props.id)}
            >
              <FontAwesomeIcon icon={faThumbsUp} /> SIM
            </button>
          </div>
        </div>
      </div>
    );
  }
}
